import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Trans } from 'react-i18next';
import { Notification, NotificationType, Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { INotification } from '@epi-models/components/Notifier';

import { getNotifications } from '../../selectors/overlays';
import * as overlaysActions from '../../actions/overlays';

import { NotifierContainer } from './Notifier.styles';

interface NotifierProps {
  hideNotification: (uid: string) => void;
  notifications: INotification[];
}

function Notifier({ hideNotification, notifications }: NotifierProps) {
  const { fontSemiBold } = useTheme();

  useEffect(() => {
    if (notifications.length > 0) {
      notifications.forEach(notification => {
        setTimeout(() => {
          hideNotification(notification.uid);
        }, 5000);
      });
    }
  }, [notifications]);

  return (
    <NotifierContainer>
      {notifications.map(({ message, level, uid, ...interpolation }) => {
        return (
          <Box key={uid} mb={1}>
            <Notification
              key={uid}
              type={level === 'warning' ? NotificationType.Important : level}
              text={
                typeof message === 'string' ? (
                  <Trans
                    i18nKey={message}
                    values={interpolation}
                    components={{
                      bold: (
                        <Box fontWeight={fontSemiBold} display="inline-block" />
                      ),
                      br: <br />
                    }}
                  />
                ) : (
                  message
                )
              }
              onClose={() => hideNotification(uid)}
            />
          </Box>
        );
      })}
    </NotifierContainer>
  );
}

const mapStateToProps = state => ({
  notifications: getNotifications(state)
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(overlaysActions, dispatch);

const ConnectedNotifier = connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifier);

export { ConnectedNotifier as Notifier };
